import { Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { Analytics } from '@angular/fire/analytics';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserSessionService } from './services/user-session.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
    private analytics = inject(Analytics);
    private userSession = inject(UserSessionService);
    private router = inject(Router);
    private translate = inject(TranslateService);
    isMobileRedirect = false;
    isSideNavOpen = true;
    collapsed = signal(false);
    @ViewChild(MatSidenav) sidenav: MatSidenav;

    // Populated by UserSessionService.init() in APP_INITIALIZER before the first route activates
    userDetails = this.userSession.userDetails;
    activeRoleDisplayName = this.userSession.activeRoleDisplayName;

    constructor() {
        this.isSideNavOpen = window.screen.orientation.type === 'landscape-primary';
        // Translation Integration with Flutter App
        if (window.Callback) {
            const mobileLangCode = window.Callback.getLanguage();
            this.translate.use(mobileLangCode);
            window.addEventListener('flutterLanguageChanged', (event) => {
                const language = (event as CustomEvent<{ languageCode: string }>).detail.languageCode;
                this.translate.use(language);
            });
        } else {
            this.translate.use('en');
        }
    }

    ngOnInit() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.isMobileRedirect = this.router.url.includes('/mobile/');
                this.userSession.syncFromMobileHost();
            }
        });
    }
}
